export default __webpack_public_path__ + "static/media/analytics.dca71772.svg";